import { Link } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";

const scopes = [
  { icon: "ri-film-line", title: "影视作品库", desc: "收录电影、电视剧、网络剧与短片，覆盖多种激情题材类型。" },
  { icon: "ri-file-text-line", title: "剧情与评论", desc: "提供详尽的剧情简介与精选观众短评，帮你快速判断是否值得一看。" },
  { icon: "ri-user-star-line", title: "明星资料", desc: "整理演员小传与代表作品，追踪你关注的面孔。" },
  { icon: "ri-bookmark-3-line", title: "策划专题", desc: "按主题打包推荐，一次看够同一风格的精彩内容。" },
];

export default function About() {
  return (
    <div className="mx-auto w-full max-w-[1400px] px-4 py-8 md:px-6 md:py-10">
      <Breadcrumb items={[{ label: "关于我们" }]} />

      <header className="mt-5 rounded-lg bg-primary-950 p-6 md:p-10">
        <span className="font-display text-xs tracking-[0.3em] text-primary-300">ABOUT</span>
        <h1 className="mt-2 text-2xl font-black text-background-50 md:text-4xl">关于激情视频</h1>
        <p className="mt-4 max-w-3xl text-sm leading-8 text-background-300 md:text-base">
          激情视频（PASSION VIDEO）是一个专注于激情题材影视剧与精彩视频内容的综合推荐平台。我们相信，好的作品值得被更多人看见。我们聚合最新上映与经典口碑作品，提供剧情介绍、演员资料与观众评论，帮助影视爱好者在海量内容中，快速找到真正打动自己的那一部。
        </p>
      </header>

      <section className="mt-10">
        <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">内容范围</h2>
        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {scopes.map((s) => (
            <div key={s.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-50 text-primary-600">
                <i className={`${s.icon} text-2xl`} />
              </span>
              <h3 className="mt-3 text-base font-semibold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="rounded-lg border border-background-200 bg-background-50 p-6">
          <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950">
            <i className="ri-team-line text-primary-500" />
            运营团队
          </h2>
          <p className="mt-4 text-sm leading-8 text-foreground-600">
            我们是一支热爱影视的编辑与产品团队，成员来自内容、设计与技术领域。每位编辑都坚持亲自观看、亲自撰写，力求让每一条推荐都真实、有温度。我们也会持续回访用户反馈，不断优化浏览、筛选与搜索体验。
          </p>
        </div>
        <div className="rounded-lg border border-background-200 bg-accent-50 p-6">
          <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950">
            <i className="ri-shield-check-line text-accent-600" />
            版权与免责声明
          </h2>
          <p className="mt-4 text-sm leading-8 text-foreground-600">
            本站所有影视作品信息、图片与文字均为示范展示内容，仅供学习与交流使用，不提供播放、下载与付费服务。如相关权利人认为内容存在不当使用，请通过联系我们页面与我们取得联系，我们将及时处理。
          </p>
        </div>
      </section>

      <section className="mt-10 rounded-lg bg-primary-950 p-6 md:p-8">
        <h2 className="text-xl font-bold text-background-50">友情链接</h2>
        <div className="mt-4 flex flex-wrap gap-3">
          {["影视资讯站", "影评社区", "电影节专题", "演员资料库"].map((name) => (
            <span
              key={name}
              className="rounded-md border border-primary-800 px-3 py-1.5 text-sm text-background-300"
            >
              {name}
            </span>
          ))}
        </div>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10 cursor-pointer"
          >
            <i className="ri-mail-line" />
            联系我们
          </Link>
        </div>
      </section>
    </div>
  );
}